// src/ctxReflector/routes.tsx
import React from "react";
import { Route } from "react-router-dom";
import BgpPage from "./components/BGP/BgpPage";
import BgpStatusPage from "./components/BGP/BgpStatusPage";
import LicensingPage from "./components/Licensing/LicensingPage";
import BgpTablesPage from "./components/L3overview/BgpTablesPage";
import LogsPage from "./components/L3overview/LogsPage";
import StatusPage from "./components/Status/StatusPage";
import LicensedPage from "./components/Instances/views/Licensed/LicensedPage";
import UnlicensedPage from "./components/Instances/views/Unlicensed/UnlicensedPage";
import HighAvailabilityPage from "./components/Instances/views/HighAvailability/HighAvailabilityPage";
import SyslogPage from "./components/Instances/views/Syslog/SyslogPage";
import HealthCheckPage from "./components/Instances/views/HealthCheck/HealthCheckPage";

import DcInventoryPage from "kontrolEdge/components/ResourceManager/DataCenter/DcInventoryPage";
import HardwareInventoryPage from "kontrolEdge/components/ResourceManager/Hardware/HardwareInventoryPage";

export const ctxReflectorRoutes = [
    <Route key="bgp" path="reflector/management/bgp/neighbors" element={<BgpPage />} />,
    <Route key="bgpStatus" path="reflector/management/bgp/status" element={<BgpStatusPage />} />,
    <Route key="licensing" path="reflector/management/licensing" element={<LicensingPage />} />,
    <Route key="l3overviewBgp" path="reflector/l3overview/bgp" element={<BgpTablesPage />} />,
    <Route key="l3overviewLogs" path="reflector/l3overview/logs" element={<LogsPage />} />,
    <Route
        key="resource-manager"
        path="reflector/Resource-Manager"
        element={<DcInventoryPage />}
    />,
    <Route
        key="hardware-inventory"
        path="reflector/Resource-Manager/hardware"
        element={<HardwareInventoryPage />}
    />,
    <Route key="status" path="reflector/status" element={<StatusPage />} />,
    <Route key="instances" path="reflector/management/instances/licensed" element={<LicensedPage />} />,
    <Route key="instances" path="reflector/management/instances/unlicensed" element={<UnlicensedPage />} />,
    <Route key="instances" path="reflector/management/instances/highavailability" element={<HighAvailabilityPage />} />,
    <Route key="instances" path="reflector/management/instances/healthcheck" element={<HealthCheckPage />} />,
    <Route key="instances" path="reflector/management/instances/syslog" element={<SyslogPage />} />,
];
